import { Linking, Platform } from "react-native";

export const callIfAvailable = (contact) => {
    if (contact) {
      let url = `tel:${contact}`;
       window.location.href = url;
    }
};

export const sendEmail = async (data, isPropertyAdded, teanentData) => {
  try {
    const email = data?.branch?.email;
    const name = data?.branch?.name;
    const ref = data?.property_name;

    let subject = `OpenBrix Enquiry - ${ref} ${data.postcode}`;

    let body = `Dear ${name},

I have recently viewed property ${ref} on ${data.postcode} on OpenBrix.

Please call me on my details below so that I can arrange a viewing.

Thank you
`;

    if (isPropertyAdded) {
      body = `Dear ${teanentData?.branchName} Branch,

I am currently renting

${teanentData?.addressLine}

I would like to discuss the following...

Kind regards,
${teanentData?.username}
`;

      subject = `Tenant Enquiry - ${teanentData?.addressLine}`;
    }

    if (email) {
      const params = new URLSearchParams({
        subject,
        body,
      });

      const mailtoUrl = `mailto:${email}?${params.toString()}`;

      window.open(mailtoUrl, "_blank");
    }

    return true;
  } catch {
    return false;
  }
};

export const sendEmailRentalOffer = async (isPropertyAdded, data) => {
  try {
    let email = data.email;
    let subject="Openflo Rental Offer Query – "+data?.postCode
    
    const url = `mailto: ${email}?subject=${subject}`;
    Linking.openURL(url).catch((err) => {
      console.error("An error occurred", err);
      return false;
    });
    return true;
  } catch {
    return false;
  }
};